import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="wa-footer">
      <div className="wa-wrap">

        {/* Col 1: Brand + blurb + socials */}
        <div className="wa-col">
          <h3 className="wa-brand">CarePlus Homes</h3>
          <p className="wa-blurb">
            Creating a stable, loving, and structured environment where children can heal, grow, and build brighter futures.
          </p>

          <div className="wa-socials" aria-label="Social links">
            <a href="https://www.youtube.com/" aria-label="YouTube" className="wa-social">
              <img src="youtube.png" alt="" />
            </a>
            <a href="https://www.linkedin.com/" aria-label="LinkedIn" className="wa-social">
              <img src="linkedin.png" alt="" />
            </a>
            <a href="https://www.twitter.com/" aria-label="X" className="wa-social" style={{ filter: "brightness(0) invert(1) opacity(.95)" }}>
              <img src="twitter.png" alt="" />
            </a>
            <a href="https://www.instagram.uk/" aria-label="Instagram" className="wa-social">
              <img src="instagram.png" alt="" />
            </a>
            <a href="https://www.facebook.uk/#" aria-label="Facebook" className="wa-social">
              <img src="facebook.png" alt="" />
            </a>
          </div>

          
        </div>

        {/* Col 2: Popular Courses */}
        <div className="wa-col">
          <h4 className="wa-head">Quick Links</h4>
          <ul className="wa-links">
            <li><a href="/about">About Us</a></li>
            <li><a href="/vacancies">Vacancies</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Col 3: Need Help */}
        <div className="wa-col">
          <h4 className="wa-head">Need Help?</h4>
          <div className="wa-help">
            <p className="wa-help-muted">Give us a call</p>
            <p className="wa-help-strong">0303 2222222</p>

            <p className="wa-help-muted">Write us an email</p>
            <p className="wa-help-strong">info@careplushomes.co.uk</p>
          </div>
        </div>

        {/* Col 4: Newsletter */}
        <div className="wa-col">
          <h4 className="wa-head">Newsletter</h4>
          <form className="wa-news" onSubmit={(e)=>e.preventDefault()}>
            <input
              type="email"
              placeholder="Enter your email"
              className="wa-input"
            />
            <button className="wa-btn" type="submit">Subscribe</button>
          </form>
        </div>

      </div>

      <div className="wa-copy">
        <p>© 2025 | All Rights Reserved | Provided by <a href="https://www.visualab.uk/">Visualab</a></p>
      </div>
    </div>
  );
};

export default Footer;
